module.exports = __webpack_public_path__ + "img/nedir-04.7e498bec.svg";